import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('PURCHASE_RECEPTION', [
    'VIEW',
    'INFO',
    'HEADER',
    'FILTER_FORM'
])
